export default "__VITE_ASSET__BZv6k4Da__"